// extracted by mini-css-extract-plugin
export default {"zoomani":"zoomani__Dfs-X","odz":"odz__qPeel","zoomdisap":"zoomdisap__EVC0A","disap":"disap__BXUMM"};